import Accordion from '../Accordion/Accordion.init.js'
import Dictionary from '../Dictionary/Dictionary.init.js'
import DictionaryWord from '../DictionaryWord/DictionaryWord.init.js'
import FactBox from '../FactBox/FactBox.init.js'
import InfoCarousel from '../InfoCarousel/InfoCarousel.init.js'
import SubNavigation from '../SubNavigation/SubNavigation.init.js'
import TheHeader from '../TheHeader/TheHeader.init.js'
import VideoComponent from '../VideoComponent/VideoComponent.init.js'

export default function (Store) {
    Accordion(Store)
    Dictionary(Store)
    DictionaryWord(Store)
    FactBox(Store)
    InfoCarousel(Store)
    SubNavigation(Store)
    TheHeader(Store)
    VideoComponent(Store)
}
